import { render } from "./old-book-list.vue?vue&type=template&id=5a9c4d86&scoped=true"
import script from "./old-book-list.js?vue&type=script&lang=js&external"
export * from "./old-book-list.js?vue&type=script&lang=js&external"

import "./old-book-list.css?vue&type=style&index=0&id=5a9c4d86&scoped=true&lang=css&external"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5a9c4d86"]])

export default __exports__